import styled from '@mui/system/styled';
import createStyles from '@mui/styles/createStyles';
import { COLORS } from '../../styles';

export const ContainerMain = styled('div')({
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const FormContainer = styled('form')({
  width: '100%',
  maxWidth: 320,
  padding: 16,
  borderRadius: 8,
  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
  backgroundColor: COLORS.WHITE,
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
});

export const styles = createStyles({
  title: {
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 4,
  },
  input: {
    marginBottom: 2,
  },
  alert: {
    marginBottom: 2,
  },

});
